import { aboutItems } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="flex-1">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">
              스카연은 어떤 커뮤니티인가요?
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              스카연은 온라인 카지노·토토 사이트의 먹튀 피해를 예방하고 검증 정보를 공유하는
              커뮤니티입니다. 사용자 제보와 전문가 검증을 통해 안전한 이용 환경을 제공하고 있습니다.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              체계적인 검증 기준을 통해 사이트를 분석하며, 보증금 제도와 개인정보 보호 정책을
              운영하고 있습니다. 믿을 수 있는 정보를 바탕으로 안전한 온라인 게임 문화를
              만들어가겠습니다.
            </p>
            <a
              href="#"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium inline-flex items-center gap-1"
            >
              스카연 운영 목적 자세히 보기
              <i className="ri-arrow-right-s-line" />
            </a>
          </div>

          <div className="flex-1 grid grid-cols-2 gap-4">
            {aboutItems.map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-lg p-4 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-primary-500 text-lg`} />
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="w-full lg:w-64 bg-white rounded-lg border border-background-200 p-5">
            <h3 className="text-base font-bold text-primary-500 mb-3">피해를 입으셨나요?</h3>
            <ul className="space-y-2 mb-4">
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-check-line text-primary-500" />
                <span>사이트 바로 제보가능</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-check-line text-primary-500" />
                <span>익명 제보 가능</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-check-line text-primary-500" />
                <span>신속한 처리 진행</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-check-line text-primary-500" />
                <span>보증금 환급 지원</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-check-line text-primary-500" />
                <span>개인정보 보장 및 유출 금지</span>
              </li>
            </ul>
            <button className="w-full bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium py-2.5 rounded transition-colors flex items-center justify-center gap-1">
              피해 제보하기
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}